import cn from 'classnames'
import {
  ELT_FORM_SECTION,
  IELTFormData,
  IRevenue,
  TComplexSectionData,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { useJbpSettings } from 'legacy/lut/features/partner360/jbpSettings'
import { useMemo } from 'react'

import { Loader } from 'core-components/library/loader'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'
import { useTableActions } from '../../../hooks/useTableActions'
import { IForceUpdateData } from '../../../models/IForceUpdateData'
import { TForceUpdateConfig } from '../../../models/TForceUpdateConfig'
import { ForceUpdate } from '../../styledComponents/forceUpdate/ForceUpdate'
import { RevenueNote } from '../../styledComponents/notes/RevenueNote'
import { StyledTable } from '../../styledComponents/styledTable/StyledTable'
import { Title } from '../../styledComponents/title/Title'
import { changeRevenueComputedFields } from '../helpers/changeRevenueComputedFields'
import { isInconsistency } from '../helpers/financialInconsistencies/isInconsistency'
import { getRevenueFullViewColumns } from '../helpers/getRevenueFullViewColumns'
import styles from '../Revenue.module.scss'

// import { RevenueTypeSelectDialog } from '../revenueTypeSelectDialog/RevenueTypeSelectDialog'
import { keyField, visibleKeys } from './configs'

interface IProps {
  netNdpValue: ActualsValueTypes
  formData: IELTFormData
  fYear: number
  fQuarter: number
  updateFormData: (data: TComplexSectionData) => void
  forceUpdate: (section: ELT_FORM_SECTION, config?: TForceUpdateConfig) => void
  forceUpdateData: IForceUpdateData
  onChangePrimitiveFormData: (field: string) => (value: string | number) => void
}

export const RevenueFullView = ({
  formData,
  fYear,
  fQuarter,
  updateFormData,
  forceUpdate,
  netNdpValue,
}: // onChangePrimitiveFormData,
// forceUpdateData,
IProps) => {
  const revenueData = useMemo(() => formData.Revenue || [], [formData.Revenue])
  const {
    isLoaded,
    jbpSettings: { fYearELT: yearFromJbpSettings },
  } = useJbpSettings()
  const { onChangeByKey } = useTableActions<IRevenue>({
    updateFormData: updateFormData,
    data: revenueData,
    changeComputedFieldsFn: changeRevenueComputedFields,
  })
  // const [showDialog, setShowDialog] = useState(false)

  const columns = useMemo(
    () =>
      getRevenueFullViewColumns({
        onChange: onChangeByKey(keyField),
        currentYear: fYear,
        currentFQuarter: fQuarter,
        isInconsistency: isInconsistency(revenueData),
        isDisabled: true,
        yearFromJbpSettings,
        netNdpValue,
      }),
    [revenueData, onChangeByKey, fYear, fQuarter, yearFromJbpSettings, netNdpValue]
  )

  const items = useMemo(() => {
    return revenueData.filter((el) => visibleKeys.includes(el.Key))
  }, [JSON.stringify(revenueData)])

  // const onForceUpdate = useCallback(() => {
  //   setShowDialog(true)
  // }, [])

  if (!isLoaded) {
    return <Loader />
  }

  return (
    <div>
      <Title
        noteContent={RevenueNote}
        variant="withBackground"
        text={getFormedEltTranslation('section-global-roll-up-by-gbu')}
        translationReplaceParams={[
          {
            key: '{netNdp}',
            value: netNdpValue.toUpperCase(),
          },
        ]}
        rightContent={
          <ForceUpdate isIcon onClick={forceUpdate} section={ELT_FORM_SECTION.REVENUE} />
        }
      />

      <StyledTable<IRevenue>
        columns={columns}
        items={items}
        keyField={keyField}
        classes={{ td: styles.tdWidth, header: cn(styles.header, styles.fullRevenue) }}
      />
      {/*<RevenueTypeSelectDialog*/}
      {/*  forceUpdateData={forceUpdateData}*/}
      {/*  onRevenueTypeClick={(revenueType, revenueDesc) => {*/}
      {/*    forceUpdate(ELT_FORM_SECTION.REVENUE, { revenue: revenueType })*/}
      {/*    onChangePrimitiveFormData('RevenueDesc')(revenueDesc)*/}
      {/*    onChangePrimitiveFormData: setShowDialog(false)*/}
      {/*  }}*/}
      {/*  closeDialog={() => {*/}
      {/*    setShowDialog(false)*/}
      {/*  }}*/}
      {/*  show={showDialog}*/}
      {/*/>*/}
    </div>
  )
}
